import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 6.81921,
		y1: 1,
		x2: 6.81921,
		y2: 13,
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 12.5781,
		y1: 7.00488,
		x2: 1.00011,
		y2: 7.00488,
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
export default SvgPlus;
